<template>
    <section class="s-camera">
        <video class="v-camera" v-show="showVideo" ref="video"></video>
        <img class="i-camera_result" v-show="!showVideo" ref="image"/>
        <div class="d-countdown-top">
            <article class="a-countdown-top" data-html2canvas-ignore>
                <p class="p-countdown-top">{{ countdown }}</p>
            </article>
        </div>
        <article class="a-camera_button" v-if="!countdown && !retake && !takeDisabled">
            <button class="b-camera_button" @click="takePhoto" data-html2canvas-ignore></button>
        </article>
        <section class="s-flash" :style="flashStyle" ref="flash" data-html2canvas-ignore></section>
        <p class="p-text" v-if="countdown" data-html2canvas-ignore>Look up</p>
        <article class="a-countdown" v-if="countdown" data-html2canvas-ignore>
            <p class="p-countdown">{{ countdown }}</p>
        </article>
        <article class="a-retake_button" v-if="retake" data-html2canvas-ignore>
            <button class="b-retake_button" @click="retakePhoto"></button>
        </article>
        <article class="a-email" v-if="showEmail">
            <form class="f-mail" @submit="mailPictureToClient">
                <div class="emailTo">
                    <p id="mailToValue" :style="getStyle" v-if="mailDataClient.to">
                        <span>{{ mailDataClient.to }}</span>
                    </p>
                    <p class="color-gray" v-else> Enter email address</p>
                    <span @click="clearEmailInput" id="email-clear-button">
                    </span>
                </div>
                <SimpleKeyboard @onChange="onChange" :input="mailDataClient.to"/>
                <button :disabled="isSendDisabled">Send</button>
                <p class="p-send-confirmation" v-if="showConfirm">You will shortly receive an email with the picture</p>
                <p class="p-send-error" v-if="showError">An error occurred, your picture was not send</p>
            </form>
        </article>
    </section>

</template>

<script>
import mailService from "@/mixins/mailService";
import authService from "@/mixins/authService";
import SimpleKeyboard from "@/components/SimpleKeyboard.vue";
import html2canvas from "@wtto00/html2canvas";

export default {
    name: 'CameraComponent',

    props: {
        msg: String,
        moduleData: Object,
        activeEvent: Object,
        photoboothAccessToken: String
    },

    components: {
        SimpleKeyboard
    },

    mixins: [
        mailService,
        authService,
    ],

    inject: ['socket'],

    computed: {
        getStyle() {
            return {'font-size': this.currentSize + 'rem'}
        },

        flashStyle() {
            return {
                backgroundColor: window._settings.flashColor
            }
        },
        isSendDisabled() {
            if (this.disableSend) {
                return true;
            }

            return !this.mailDataClient.to || !this.mailDataClient.to.toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        },
    },

    data() {
        return {
            countdown: 0,
            countdownDuration: 5,
            mailDataClient: {
                to: null,
                subject: 'Thank you for visiting the Worldline Innovation & Experience Centre',
                body: '<p>Hi there,</p>' +
                    '<p>We’re excited to share a special memory from your recent visit to the Worldline Innovation & Experience Centre! Your photo is attached.</p>' +
                    '<p>We invite you to share your photo on social media using our hashtag #WorldlineIEC. We’d love to see it and hear about your experience!</p>' +
                    '<p>We also value your feedback. Please take a moment to fill out our <a href="https://forms.office.com/e/dHxm0GcEkm">satisfaction survey.</a> — your input helps us improve.</p>' +
                    '<p>If you have any questions or want to learn more about our Innovation Centre, feel free to reach out!</p>' +
                    '<p>We look forward to seeing you again soon!</p>' +
                    '<p>Best regards,</p>' +
                    '<p>The Worldline IEC Team</p> ',
                projectId: window._settings.projectId,
                assets: {},
                attachments: [],
                attachmentNames: ['IEC_Photobooth_picture.jpg']
            },
            mailDataWorldline: {
                to: '',
                subject: 'Thank you for visiting the Worldline Innovation & Experience Centre',
                body: '<p>Hi there,</p>' +
                    '<p>We’re excited to share a special memory from your recent visit to the Worldline Innovation & Experience Centre! Your photo is attached.</p>' +
                    '<p>We invite you to share your photo on social media using our hashtag #WorldlineIEC. We’d love to see it and hear about your experience!</p>' +
                    '<p>We also value your feedback. Please take a moment to fill out our <a href="https://forms.office.com/e/dHxm0GcEkm">satisfaction survey.</a> — your input helps us improve.</p>' +
                    '<p>If you have any questions or want to learn more about our Innovation Centre, feel free to reach out!</p>' +
                    '<p>We look forward to seeing you again soon!</p>' +
                    '<p>Best regards,</p>' +
                    '<p>The Worldline IEC Team</p> ',
                projectId: window._settings.projectId,
                assets: {},
                attachments: [],
                attachmentNames: ['IEC_Photobooth_picture.jpg']
            },
            showVideo: true,
            retake: false,
            showEmail: false,
            email: null,
            showConfirm: false,
            showError: false,
            disableSend: false,
            startingSize: 2.5,
            currentSize: 2.5,
            takeDisabled: false,
            maxWidth: 1090,
            maxHeight: 300,
            originalImage: null,
            printImage: null,
            printFormData: null,
            isDefaultEvent: false,
            config: this.moduleData.json,
            defaultConfig: this.moduleData.json.default
        }
    },

    watch: {
        "mailDataClient.to": {
            handler() {
                const pTag = document.getElementById("mailToValue");
                if (pTag) {
                    const width = pTag.clientWidth;
                    const maxWidth = 525;
                    if (width >= maxWidth) {
                        this.currentSize -= 0.1;
                    }
                }
            }
        }
    },

    async created() {
        await this.initCamera();

        if (this.activeEvent) {
            this.isDefaultEvent = this.activeEvent.name.includes("Default Event");
        }

        this.countdownDuration = window._settings.countdownDuration + 1;
        this.mailDataWorldline.to = this.isDefaultEvent ? this.defaultConfig.emailAddress : this.config.emailAddress;
    },

    methods: {
        async initCamera() {
            const camera = window._settings.camera;

            let cameraId = "";
            const isXXLWall = this.config.isXXLWall;
            let param = {audio: false};
            const devices = await navigator.mediaDevices.enumerateDevices();

            if (isXXLWall) {
                devices.forEach((device) => {
                    if (device.label.includes(camera)) {
                        cameraId = device.deviceId;
                    }
                });
            } else {
                document.querySelector('.d-countdown-top').id = 'd-countdown-top-16';
                let workingDevice = await this.getWorkingCamera(devices);
                cameraId = workingDevice.deviceId;
            }

            if (cameraId) {
                param.video = {
                    deviceId: {exact: cameraId}
                }
            } else {
                param.video = true;
            }

            const stream = await navigator.mediaDevices.getUserMedia(param);

            const videoElement = this.$refs.video;
            videoElement.srcObject = stream;
            videoElement.play();
        },

        async getWorkingCamera(devices) {
            let cameraDevices = devices.filter((device) => device.kind === "videoinput")
            let deviceCount = cameraDevices.length;
            let workingDeviceFound = false;
            let devicesChecked = 0;

            while (!workingDeviceFound) {
                if (devicesChecked > deviceCount) {
                    //return last camera device in the array
                    return cameraDevices.pop();
                }

                let device = cameraDevices.shift();

                try {
                    await navigator.mediaDevices.getUserMedia({
                        video: {
                            deviceId: {exact: device.deviceId}
                        }
                    });
                    workingDeviceFound = true;
                    return device;
                } catch (e) {
                    devicesChecked++;
                    //does not work, skip device
                }
            }
        },

        async takePhoto() {
            this.takeDisabled = true;
            await this.countdownToPhoto();
            let image = null;
            image = await this.makePicture();

            image = image.replace('data:image/jpeg;base64,', "");

            this.retake = true;
            this.showEmail = true;

            this.mailDataClient.attachments.push(image);
            this.mailDataWorldline.attachments.push(image);

            if (this.config.isXXLWall) {
                await this.createSmallPicture();
            }

            this.downloadImage(this.mailDataClient.attachments[0], "169");

            if (this.originalImage) {
                this.downloadImage(this.originalImage);
            }

            if ((this.isDefaultEvent ? this.defaultConfig.background_photo : this.config.background_photo) && this.activeEvent) {
                await this.createPrintPicture();
            }

            this.mailPictureToWorldline();
            this.takeDisabled = false;
        },

        retakePhoto() {
            this.$refs.video.play();
            this.retake = false;
            this.showEmail = false;
            this.showVideo = true;
            this.mailDataClient.attachments = [];
            this.mailDataWorldline.attachments = [];
            this.mailDataClient.attachmentNames = ['IEC_Photobooth_picture.jpg'];
            this.mailDataWorldline.attachmentNames = ['IEC_Photobooth_picture.jpg'];
            this.takePhoto();
        },

        clearEmailInput() {
            this.mailDataClient.to = null;
        },

        countdownToPhoto() {
            this.$emit('togglePulse');
            return new Promise((resolve) => {
                this.countdown = this.countdownDuration;
                const interval = setInterval(() => {
                    this.countdown--;
                    if (this.countdown === 1) {
                        this.showFlash();
                    }

                    if (this.countdown === 0) {
                        clearInterval(interval);
                        this.$emit('togglePulse');
                        resolve();
                    }
                }, 1000);
            });
        },

        showFlash() {
            let opacity = 0;
            const interval = setInterval(() => {
                opacity += 0.1;
                this.$refs.flash.style.opacity = opacity;
                if (opacity >= 1) {
                    clearInterval(interval);
                    const interval2 = setInterval(() => {
                        opacity -= 0.05;
                        this.$refs.flash.style.opacity = opacity;
                        if (opacity <= 0) {
                            clearInterval(interval2);
                        }
                    }, 100);
                }
            }, 100);
        },

        async makePicture() {
            return new Promise((resolve) => {
                const video = this.$refs.video;
                video.pause();

                const width = window.innerWidth;
                const height = window.innerHeight;

                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;

                html2canvas(
                    document.querySelector("#app"),
                    {
                        allowTaint: true,
                        width: width,
                        height: height,
                        windowWidth: width,
                        windowHeight: height,

                    }
                )
                    .then(canvas => {
                        resolve(canvas.toDataURL('image/jpeg'));
                    });

                document.querySelector('#app').append(canvas);
            });
        },

        async createSmallPicture() {
            const video = this.$refs.video;
            video.pause();

            const width = 3840;
            const height = 2160

            //log video width and height
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext('2d');
            //set background color from settings
            ctx.fillStyle = window._settings.bgColor;
            ctx.fillRect(0, 0, width, height);

            //draw video on canvas center aligned with dimensions 2775 x 1560 (this is the inner space in the 16/9 background)
            let videoWidth = 2775;
            let videoHeight = videoWidth / video.videoWidth * video.videoHeight;
            const videoX = 530;
            const videoY = 370;

            if (videoHeight < 1580) {
                videoHeight = 1580; // ensure minimum height of 1580px
                videoWidth = videoHeight / video.videoHeight * video.videoWidth; // adjust width accordingly
            }

            //draw webcam
            ctx.drawImage(video, videoX, videoY, videoWidth, videoHeight);

            //draw moduledata.json.background_small on it
            if ((this.isDefaultEvent ? this.defaultConfig.background_small : this.config.background_small) && (this.isDefaultEvent ? this.defaultConfig.background_small.path : this.config.background_small.path)) {
                const background = await this.getImage(this.isDefaultEvent ? this.defaultConfig.background_small.path : this.config.background_small.path);
                ctx.drawImage(background, 0, 0, width, height);
            }

            let imageHeight = 0;
            let imageWidth = 0;
            let topOffset = 0;
            //draw logo_left
            if ((this.isDefaultEvent ? this.defaultConfig.logo_left : this.config.logo_left) && (this.isDefaultEvent ? this.defaultConfig.logo_left.path : this.config.logo_left.path)) {
                const logoLeft = await this.getImage(this.isDefaultEvent ? this.defaultConfig.logo_left.path : this.config.logo_left.path);
                let dimensions = this.getDimensions(logoLeft);

                if (this.config.useRoundSquareLayout) {
                    dimensions = this.resizeImage(dimensions);
                    imageWidth = dimensions.imageWidth;
                    imageHeight = dimensions.imageHeight;
                    topOffset = ((this.maxHeight - imageHeight) / 2) + 1000;
                    const leftOffsetFirst = 275 - ((imageWidth) / 2);
                    ctx.drawImage(logoLeft, leftOffsetFirst, topOffset, imageWidth, imageHeight);
                } else {
                    imageWidth = dimensions.imageWidth;
                    imageHeight = dimensions.imageHeight;
                    topOffset = ((this.maxHeight - imageHeight) / 2) + 50;
                    const leftOffsetFirst = 520;
                    ctx.drawImage(logoLeft, leftOffsetFirst, topOffset, imageWidth, imageHeight);
                }

            }

            //draw logo_right
            if (this.isDefaultEvent ? this.defaultConfig.logo_right.path : this.config.logo_right.path) {
                const logoRight = await this.getImage(this.isDefaultEvent ? this.defaultConfig.logo_right.path : this.config.logo_right.path);
                let dimensions = this.getDimensions(logoRight);

                if (this.config.useRoundSquareLayout) {
                    dimensions = this.resizeImage(dimensions);
                    imageWidth = dimensions.imageWidth;
                    imageHeight = dimensions.imageHeight;
                    topOffset = ((this.maxHeight - imageHeight) / 2) + 1000;
                    let leftOffset = 3565 - (imageWidth / 2);
                    ctx.drawImage(logoRight, leftOffset, topOffset, imageWidth, imageHeight);
                } else {
                    imageWidth = dimensions.imageWidth;
                    imageHeight = dimensions.imageHeight;
                    topOffset = ((this.maxHeight - imageHeight) / 2) + 50;
                    let leftOffset = 3840 - imageWidth - 490;
                    ctx.drawImage(logoRight, leftOffset, topOffset, imageWidth, imageHeight);
                }
            }

            const image = canvas.toDataURL('image/jpeg');
            this.originalImage = this.mailDataClient.attachments[0];
            this.mailDataClient.attachments[0] = image.replace('data:image/jpeg;base64,', "");

            // Also send this version to WL
            this.mailDataWorldline.attachments.push(this.mailDataClient.attachments[0]);
            this.mailDataWorldline.attachmentNames.push('IEC_Photobooth_picture_small.jpg');
        },

        async createPrintPicture() {
            const video = this.$refs.video;
            video.pause();

            const width = 1200;
            const height = 102 / 152 * 1200; // 102 / 152 is the paper format

            //log video width and height
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext('2d');
            //set background color from settings
            ctx.fillStyle = window._settings.bgColor;
            ctx.fillRect(0, 0, width, height);

            //draw video on canvas center aligned with dimensions 1040 x 580 (this is the inner space in the print background)
            let videoWidth = 1040;
            let videoHeight = videoWidth / video.videoWidth * video.videoHeight;
            const videoX = 80;
            const videoY = 145;

            if (videoHeight < 580) {
                videoHeight = 580; // ensure minimum height of 800px
                videoWidth = videoHeight / video.videoHeight * video.videoWidth; // adjust width accordingly
            }

            //draw webcam
            ctx.drawImage(video, videoX, videoY, videoWidth, videoHeight);

            //draw moduledata.json.background_photo on it
            if ((this.isDefaultEvent ? this.defaultConfig.background_photo : this.config.background_photo) && (this.isDefaultEvent ? this.defaultConfig.background_photo.path : this.config.background_photo.path)) {
                const background = await this.getImage(this.isDefaultEvent ? this.defaultConfig.background_photo.path : this.config.background_photo.path);
                ctx.drawImage(background, 0, 0, width, height);
            }

            let imageHeight = 0;
            let imageWidth = 0;
            let topOffset = 0;
            //draw logo_left
            if (this.isDefaultEvent ? this.defaultConfig.logo_left.path : this.config.logo_left.path) {
                const logoLeft = await this.getImage(this.isDefaultEvent ? this.defaultConfig.logo_left.path : this.config.logo_left.path);
                let dimensions = this.getDimensions(logoLeft);

                imageWidth = dimensions.imageWidth * 0.37;
                imageHeight = dimensions.imageHeight * 0.37;
                topOffset = ((this.maxHeight * 0.37 - imageHeight) / 2) + 20;
                const leftOffsetFirst = 80;
                ctx.drawImage(logoLeft, leftOffsetFirst, topOffset, imageWidth, imageHeight);
            }

            //draw logo_right
            if (this.isDefaultEvent ? this.defaultConfig.logo_right.path : this.config.logo_right.path) {
                const logoRight = await this.getImage(this.isDefaultEvent ? this.defaultConfig.logo_right.path : this.config.logo_right.path);
                let dimensions = this.getDimensions(logoRight);

                imageWidth = dimensions.imageWidth * 0.37;
                imageHeight = dimensions.imageHeight * 0.37;
                topOffset = ((this.maxHeight * 0.37 - imageHeight) / 2) + 20;
                let leftOffset = 1200 - imageWidth - 80;
                ctx.drawImage(logoRight, leftOffset, topOffset, imageWidth, imageHeight);
            }

            const image = canvas.toDataURL('image/jpeg');
            this.printImage = image.replace('data:image/jpeg;base64,', "");
            this.downloadImage(this.printImage, "64");

            const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpg'));
            const formData = new FormData();
            formData.append('photo', blob, `worldline_photobooth_${this.activeEvent.id}_${Date.now()}.jpg`); // Add the blob with a filename
            this.printFormData = formData;
        },

        async uploadPrintPicture() {
            if (!this.printFormData) {
                return;
            }

            const url = `${window._settings.photoboothApiHost}/api/v1/events/${this.activeEvent.id}/photos`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': this.photoboothAccessToken
                },
                body: this.printFormData
            });

            if (!response.ok) {
                throw new Error('Failed to upload print picture');
            }
        },

        getDimensions(image) {
            const maxWidth = this.maxWidth;
            const maxHeight = this.maxHeight

            let imageWidth = image.width;
            let imageHeight = image.height;

            if (imageWidth > maxWidth) {
                imageHeight *= maxWidth / imageWidth;
                imageWidth = maxWidth;
            }

            if (imageHeight > maxHeight) {
                imageWidth *= maxHeight / imageHeight;
                imageHeight = maxHeight;
            }

            return {imageWidth, imageHeight};
        },

        resizeImage(dimensions, maxDimension = 300) {
            let imageWidth = dimensions.imageWidth;
            let imageHeight = dimensions.imageHeight;

            // Determine the scaling factor
            let scalingFactor = 1;

            if (imageWidth > maxDimension || imageHeight > maxDimension) {
                // Downsize
                scalingFactor = maxDimension / Math.max(imageWidth, imageHeight);
            } else if (imageWidth < maxDimension && imageHeight < maxDimension) {
                // Upscale
                scalingFactor = maxDimension / Math.min(imageWidth, imageHeight);
            }

            return {
                imageWidth: Math.round(imageWidth * scalingFactor),
                imageHeight: Math.round(imageHeight * scalingFactor)
            };
        },

        async mailPictureToWorldline() {
            if (window._settings.debug) {
                return;
            }

            try {
                let aemPromises = [
                    this.sendToAEM(this.mailDataClient.attachments[0], "169"),
                ];

                if (this.originalImage) {
                    aemPromises.push(this.sendToAEM(this.originalImage));
                }

                if (this.printImage) {
                    aemPromises.push(this.sendToAEM(this.printImage, "64"));
                }

                await Promise.all(
                    [
                        this.sendMail(this.mailDataWorldline),
                        ...aemPromises
                    ]
                )
            } catch (e) {
                console.error(e);
            }
        },

        async mailPictureToClient(e) {
            e.preventDefault();

            try {
                this.disableSend = true;

                await this.sendMail(this.mailDataClient);
                await this.uploadPrintPicture();

                this.showConfirm = true;
            } catch (e) {
                this.showError = true;
                console.error(e);
            } finally {
                this.disableSend = false;

                setTimeout(() => {
                    this.showConfirm = false;
                    this.showError = false;
                }, 5000);
            }
        },

        async sendToAEM(image, aspect = "329") {
            if (window._settings.debug) {
                return;
            }

            const data = {image, aspect};

            const headers = new Headers();
            headers.append('Content-Type', 'application/json');

            await fetch(`${window._settings.proxyUrl}/upload`, {
                method: "POST",
                body: JSON.stringify(data),
                headers
            })
        },

        downloadImage(image, aspect = "329") {
            if (!this.socket.connected) return;

            const imageData = 'data:image/jpeg;base64,' + image;
            const chunkSize = 50000; // 50KB chunks

            console.log("Sending image data in chunks to the server");
            // Send in chunks
            const imageId = Date.now().toString();
            const totalChunks = Math.ceil(imageData.length / chunkSize);

            this.socket.emit('download-start', { imageId, totalChunks });

            for (let i = 0; i < imageData.length; i += chunkSize) {
                const chunk = imageData.slice(i, i + chunkSize);
                const chunkIndex = Math.floor(i / chunkSize);
                const progress = Math.min(100, Math.ceil((chunkIndex + 1) / totalChunks * 100));

                this.socket.emit('download-chunk', { imageId, chunk, chunkIndex, totalChunks, progress });
            }

            this.socket.emit('download-complete', { imageId, aspect });
        },

        onChange(input) {
            this.mailDataClient.to = input;
        },

        async getImage(path) {
            if (!path) {
                return null;
            }

            const response = await fetch(`${window._settings.proxyUrl}/image`, {
                method: 'POST',
                body: JSON.stringify({
                    "path": path
                })
            })

            const data = await response.blob()
            return createImageBitmap(data);
        },
    }
    ,
}
</script>

<style>
:root {
    --color-photo: rgba(0, 255, 0, 0.55);
    --color-photo-text: #FFFFFF;
    --color-countdown: rgba(0, 255, 0, 0.55);
    --color-countdown-text: #ffffff;
    --color-retake: rgba(0, 255, 0, 0.55);
    --color-retake-text: #ffffff;
    --button-size: 550px;
    --font-size: 5.5rem;
}

.s-camera {
    width: 3100px !important;
    max-height: 2160px !important;
    aspect-ratio: 16 / 9;
}

.v-camera,
.i-camera_result {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 0;
}

.a-email {
    position: absolute;
    width: var(--button-size);
    left: calc(4480px - calc(var(--button-size) / 2));
    top: calc(50% - 216px);
    display: flex;
    flex-direction: column;
}

.a-email form input {
    font-size: 3rem;
    width: 545px;

}

.a-email form button {
    font-size: 3rem;
    width: 50%;

}

.a-camera_button,
.a-countdown,
.a-retake_button {
    position: absolute;
    left: calc(50% - calc(var(--button-size) / 2));
    bottom: calc(50% - calc(var(--button-size) / 2));
    width: var(--button-size);
    height: var(--button-size);
    display: flex;
    justify-content: center;
    align-items: center;
}

@media (min-width: 7200px) {
    .d-countdown-top {
        right: -215px !important;
    }
}

.d-countdown-top {
    margin-top: 18px;
    position: absolute;
    right: -57px;
    top: 0px;
    height: 10vh;
    width: 50%;
    display: flex;
    justify-content: flex-start;
    z-index: 1000;
}

#d-countdown-top-16 {
    margin-top: 2.5%;
}

.a-retake_button {
    left: calc(3200px - calc(var(--button-size) / 2));
    bottom: calc(50% - calc(var(--button-size) / 2));
}

.a-countdown,
.a-camera_button,
.a-retake_button {
    border-radius: 50%;
}

.a-countdown,
.a-countdown-top {
    background-image: url("../assets/media/icon_border_2000x2000.png");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-color: transparent;
    color: var(--color-countdown-text);
}

.a-countdown-top {
    height: 9vh;
    width: 9vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.b-camera_button,
.b-retake_button {
    width: 100%;
    height: 100%;
    border-radius: 49vw;
    border: none;
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-color: transparent;

}

.b-camera_button {
    background-image: url("../assets/media/icon_take_2000x2000.png");
}

.b-retake_button {
    background-image: url("../assets/media/icon_retake_2000x2000.png");
}

.b-camera_button,
.p-countdown,
.p-countdown-top,
.b-retake_button {
    font-size: var(--font-size);
    z-index: 1000;
}

.s-flash {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    opacity: 0;
}

.f-mail {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 40px;
}

.p-send-confirmation,
.p-send-error {
    background-color: #f0fdf4;
    color: #16a34a;
    font-size: 2.5rem;
    text-align: center;
    padding: 1rem;
}

.p-send-error {
    background-color: #fef2f2;
    color: #dc2626;
}

.p-text {
    font-size: 8rem;
    text-align: center;
    position: absolute;
    top: calc(50vh - calc(var(--button-size) * 0.8));
    font-weight: bold;
    color: #00c1aa;
    width: var(--button-size);
    left: calc(50% - calc(var(--button-size) / 2));
}

.emailTo {
    width: 100%;
    height: 60px;
    font-size: 2.5rem;
    background-color: white;
    padding: 10px 2px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.emailTo p {
    margin-left: 5px;
    line-height: 60px;
    overflow-x: auto;
    direction: rtl;

    span {
        direction: ltr;
        unicode-bidi: bidi-override;
    }

    &::-webkit-scrollbar {
        display: none;
    }
}

.color-gray {
    color: #666666;
}

@media screen and (max-width: 3840px) {
    .a-retake_button {
        left: calc(35% - calc(var(--button-size) / 2));
    }

    .a-email {
        left: calc(65% - calc(var(--button-size) / 2));
    }

}

#email-clear-button {
    position: relative;
    height: 80px;
    width: 80px;
    border: none;
    background-color: rgba(0, 0, 0, 0);
    background-image: url("../assets/media/close.svg");
    background-repeat: no-repeat;
    background-size: 50%;
    background-position: center;
    flex-shrink: 0;
}
</style>
